import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import Datepicker from "../components/Form/Datepicker";
import DatePicker from "../components/Form/Datepicker";

export const DELAY_20_39_MINUTES = "delay_20_39_minutes";
export const DELAY_40_59_MINUTES = "delay_40_59_minutes";
export const DELAY_OVER_60_MINUTES = "delay_over_60_minutes";

export default function Delay() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    function setFieldValue(arg0: string, val: string): void {
        throw new Error("Function not implemented.");
    }

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });
                    navigate("/betalningssatt");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    delay: Yup.string().test(
                        "at-least-one-radio-selected",
                        "Vänligen välj ett svarsalternativ för att gå vidare till nästa steg",
                        (value) => {
                            return value === DELAY_20_39_MINUTES ||
                                value === DELAY_40_59_MINUTES ||
                                value === DELAY_OVER_60_MINUTES;
                        }
                    ),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"20"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="delay">
                                    Hur stor blev förseningen?
                                </h2>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}
                                <div
                                    role="radiogroup"
                                    aria-labelledby="delay"
                                    className="radio-group"
                                >
                                    {errors.delay && (
                                        <span
                                            aria-describedby="forMe forOther"
                                            className="validation-error"
                                        >
                                            {errors.delay.toString()}
                                        </span>
                                    )}

                                    <div className={errors.delay ? "has-error" : ""}>
                                        <Field
                                            id="delay2039"
                                            type="radio"
                                            name="delay"
                                            value={DELAY_20_39_MINUTES}
                                            checked={values.delay === DELAY_20_39_MINUTES}
                                        />
                                        <label htmlFor="delay2039">Jag blev 20 - 39 minuter försenad</label>
                                    </div>

                                    <div className={errors.delay ? "has-error" : ""}>
                                        <Field
                                            id="delay4059"
                                            type="radio"
                                            name="delay"
                                            value={DELAY_40_59_MINUTES}
                                            checked={values.delay === DELAY_40_59_MINUTES}
                                        />
                                        <label htmlFor="delay4059">Jag blev 40 - 59 minuter försenad</label>
                                    </div>

                                    <div className={errors.delay ? "has-error" : ""}>
                                        <Field
                                            id="delayOver60"
                                            type="radio"
                                            name="delay"
                                            value={DELAY_OVER_60_MINUTES}
                                            checked={values.delay === DELAY_OVER_60_MINUTES}
                                        />
                                        <label htmlFor="delayOver60">Jag blev mer än 60 minuter försenad</label>
                                    </div>
                                </div>
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div >
    );
}
